import React from "react";
import { OrgSpaceWidgetAddRouteKey } from "./OrgSpaceWidgetAddDrawer";
import { WidgetAddMasterComponent } from "../../Storecast/Storecast/WidgetAdd/WidgetAddMasterComponent";
import { WACategoryType } from "../../Storecast/Storecast/WidgetAdd/Categories/WACategoryType";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

export function OrgSpaceWidgetAddCategories(props: {
  selected?: OrgSpaceWidgetAddRouteKey;
  chevron?: boolean;
  onPressIn?(key: OrgSpaceWidgetAddRouteKey): void;
  onPress(key: OrgSpaceWidgetAddRouteKey): void;
}) {
  const intl_tokens = useIntlTokens();
  const sections: { data: WACategoryType<OrgSpaceWidgetAddRouteKey>[] }[] = [
    {
      data: [
        {
          title: intl_tokens.Note,
          icon: "edit",
          color: "#A97AEC",
          key: "OrgSpaceWACategoryNote",
        },
        {
          title: intl_tokens.Files,
          icon: "files",
          color: "#000000",
          key: "OrgSpaceWACategoryFile",
        },
      ],
    },
  ];

  return (
    <WidgetAddMasterComponent {...props} type="fullsize" sections={sections} />
  );
}
